import { Point, Serie } from "@nivo/line";
import ChartTooltipPositionWrapper, {
  TooltipInteractionType,
} from "components/dataVisualization/chartComponents/ChartTooltip/ChartTooltipPositionWrapper";
import TooltipValuesTable from "components/dataVisualization/chartComponents/ChartTooltip/TooltipValuesTable/TooltipValuesTable";
import {
  StyledTooltip,
  StyledTooltipTitle,
  StyledTooltipSettlementPeriod,
} from "components/dataVisualization/chartComponents/ChartTooltip/style";
import { getTabulatedTooltipValues } from "components/dataVisualization/chartComponents/ChartTooltip/utils";
import {
  drmConfig,
  lolpConfig,
} from "components/dataVisualization/lolpdrm/lolpdrmChartConfig";
import React from "react";
import {
  formatDateTimeString,
  DateFormat,
  getDifferenceInMs,
} from "utils/dateHelpers";

interface Props {
  allChartData: Serie[];
  minXAxisValue: Date;
  maxXAxisValue: Date;
  highlightedPoint: Point;
}

const LolpdrmTooltip: React.FC<Props> = ({
  allChartData,
  minXAxisValue,
  maxXAxisValue,
  highlightedPoint,
}) => {
  const date = highlightedPoint.data.x as Date;

  const distanceFromMin = getDifferenceInMs(date, minXAxisValue);
  const distanceFromMax = getDifferenceInMs(date, maxXAxisValue);
  const pointIsInLeftHalf = distanceFromMax > distanceFromMin;

  const { tooltipValues: drmValues, settlementPeriod } =
    getTabulatedTooltipValues(drmConfig.datasetCategories, allChartData, date);

  const { tooltipValues: lolpValues } = getTabulatedTooltipValues(
    lolpConfig.datasetCategories,
    allChartData,
    date
  );

  return (
    <ChartTooltipPositionWrapper
      pointIsInLeftHalf={pointIsInLeftHalf}
      interactionType={TooltipInteractionType.Slice}
    >
      <StyledTooltip data-test-id="chart-tooltip">
        <StyledTooltipTitle>
          {formatDateTimeString(date, DateFormat.DateTime)}
        </StyledTooltipTitle>
        <StyledTooltipSettlementPeriod data-test-id="chart-tooltip-settlement-period">
          <span>Settlement Period</span>
          <span>{settlementPeriod}</span>
        </StyledTooltipSettlementPeriod>
        <TooltipValuesTable config={drmConfig} tooltipValues={drmValues} />
        <TooltipValuesTable config={lolpConfig} tooltipValues={lolpValues} />
      </StyledTooltip>
    </ChartTooltipPositionWrapper>
  );
};

export default LolpdrmTooltip;
